export default "__VITE_ASSET__zVUk_8$8tBc3ydqwFyM8VA__"